export default __webpack_public_path__ + "static/media/gallery_08.5018949b.jpg";